import { FC } from 'react';
import { Box, Center, Circle } from 'styled-system/jsx';
import CustomLabel from '@/common/components/base/customLabel/CustomLabel.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { FileCardPropsType } from '@/modules/Dashboard/components/fileCard/FileCard.type.ts';

const FileCard: FC<FileCardPropsType> = ({
  title,
  Icon,
  titleLabel,
  ...color
}) => (
  <Center
    shadow="cardShadow"
    backgroundColor="white"
    borderRadius="8px"
    padding="0 1rem"
    flexDir="column"
    cursor="pointer"
  >
    <Circle
      transform="translateY(-1.5rem)"
      border="1px solid {colors.gray-3}"
      borderRadius="50%"
    >
      {Icon}
    </Circle>
    <Center flexDirection="column" marginTop="-1rem" paddingBottom="0.5rem">
      <Typography mb="10px" textStyle="b2">
        {title}
      </Typography>
      <Box mb="5px">
        <CustomLabel title={titleLabel} color={color.color} />
      </Box>
    </Center>
  </Center>
);

export default FileCard;
